import { render, staticRenderFns } from "./ItemsTableFTL.vue?vue&type=template&id=0d42fd63&scoped=true&"
import script from "./ItemsTableFTL.vue?vue&type=script&lang=js&"
export * from "./ItemsTableFTL.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTableFTL.vue?vue&type=style&index=0&id=0d42fd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42fd63",
  null
  
)

export default component.exports